


const ThankYou:React.FC = ()=>{


    return <div>Thanks</div>
}

export default ThankYou